import { SPORT_CONFIG } from '../data/sports';

export const getSportOptions = (fieldKey: string, formData: any, baseOptions?: any): any[] | undefined => {
  const { sport, team1, team2 } = formData;

  if (fieldKey === 'league') {
    if (!sport) return baseOptions;
    const sportData = SPORT_CONFIG[sport as keyof typeof SPORT_CONFIG];
    return sportData?.leagues || baseOptions;
  }

  if (fieldKey === 'team1' || fieldKey === 'team2') {
    if (!sport) return baseOptions;
    const sportData = SPORT_CONFIG[sport as keyof typeof SPORT_CONFIG];
    let options = sportData?.teams || baseOptions;

    // Excluir equipo ya seleccionado
    if (fieldKey === 'team1' && team2) {
      options = options.filter((opt: any) => opt.value !== team2);
    }
    if (fieldKey === 'team2' && team1) {
      options = options.filter((opt: any) => opt.value !== team1);
    }

    return options;
  }

  if (fieldKey === 'tournament') {
    if (!sport) return baseOptions;
    const sportData = SPORT_CONFIG[sport as keyof typeof SPORT_CONFIG];
    return sportData?.tournaments || baseOptions;
  }

  return baseOptions;
};
